import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'environments/environment';


//TODO
// Cyber doesn't want the imeplementation key exposed in the code, but currently the Application Insights SDK requires it to initialize. Need to find a way to hide it.
// For now, we will disable this code. 
// In the new SO cloud, there is not a speciific applicationInsights specific to this particulatr
// application, so putting the insights into the overall General insights needs to be decided if it is worth it.
// If we decide to implement this, it will likely need to done via an API call to the backend to hide the key and
// have the API do it on behalf of the frontend.


@Injectable({
    providedIn: "root",
})
export class ApplicationInsightsLoggingService {
  appInsights: ApplicationInsights;
  constructor() {
   // this.appInsights = new ApplicationInsights({
   //   config: {
   //     instrumentationKey: environment.appInsights.instrumentationKey,
   //     enableAutoRouteTracking: true, // option to log all route changes
   //     accountId : "not set yet"
   //   }
   // });
   // this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) { // option to call manually
   // this.appInsights.trackPageView({
   //   name: name,
   //   uri: url
   // });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    //this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    //this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    //this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    //this.appInsights.trackTrace({ message: message}, properties);
  }
}